/**
 * Created by vladislav on 08.05.2020
 */

const NoConnectionWindow = CleverappsWindow.extend({
    onWindowLoaded: function () {
        const styles = cleverapps.styles.NoConnectionWindow;

        this._super({
            title: Messages.get("NoConnectionWindow.title"),
            name: "noconnectionwindow",
            content: this.getContent(),
            button: {
                width: styles.button.width,
                height: styles.button.height, 
                text: Messages.get("OK"),
                onPressed: function () {
                    this.close();
                }.bind(this)
            }
        });
    },

    getContent: function () {
        const styles = cleverapps.styles.NoConnectionWindow;

        const node = new cc.Node();
        node.setAnchorPoint(0.5, 0.5);
        node.setContentSize2(styles.animation);
        const animation = new cleverapps.Spine(bundles.noconnection_window.jsons.no_connection_json);
        node.addChild(animation);
        animation.setAlignment(node.width / 2, node.height / 2);
        animation.setAnimation(0, "animation", true);

        // eslint-disable-next-line no-restricted-syntax
        const text = cleverapps.UI.generateTTFText(Messages.get("RestartWindow.CheckInternetConnection"), cleverapps.styles.FONTS.WINDOW_SMALL_TEXT);
        text.setDimensions(styles.text.width, 0);
        text.setHorizontalAlignment(cc.TEXT_ALIGNMENT_CENTER);

        const layout = new cleverapps.Layout([node, text], {
            direction: cleverapps.UI.VERTICAL,
            margin: styles.margin
        });

        return layout;
    },

    listBundles: function () {
        return ["noconnection_window"];
    }
});

cleverapps.styles.NoConnectionWindow = {
    width: 500,
    height: 800,

    margin: 30,

    animation: {
        width: 400,
        height: 400
    },

    text: {
        width: 480
    },

    button: {
        width: 200,
        height: 100
    }
};